import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/KWRI/real-react/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { State } from 'react-powerplug';
import Pagination from '.';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "pagination"
    }}>{`Pagination`}</h1>
    <p>{`Pagination controls are groups of buttons that allow the user to navigate through long lists by organizing the content into multiple, shorter pages rather than a single, long page.`}</p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Pagination} mdxType="Props" />
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <h3 {...{
      "id": "default-usage"
    }}>{`Default Usage`}</h3>
    <Playground __position={1} __code={'<State initial={{ pageNum: 1 }}>\n  {({ state, setState }) => (\n    <Pagination\n      currentPage={state.pageNum}\n      pageSize={25}\n      totalItems={200}\n      onPageChange={pageNum => setState({ pageNum })}\n    />\n  )}\n</State>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      State,
      Pagination
    }} mdxType="Playground">
  <State initial={{
        pageNum: 1
      }} mdxType="State">
    {({
          state,
          setState
        }) => <Pagination currentPage={state.pageNum} pageSize={25} totalItems={200} onPageChange={pageNum => setState({
          pageNum
        })} mdxType="Pagination" />}
  </State>
    </Playground>
    <h3 {...{
      "id": "with-page-size"
    }}>{`With Page Size`}</h3>
    <Playground __position={2} __code={'<State initial={{ pageNum: 1, pageSize: 25 }}>\n  {({ state, setState }) => (\n    <Pagination\n      currentPage={state.pageNum}\n      pageSize={state.pageSize}\n      totalItems={200}\n      onPageChange={pageNum => setState({ pageNum })}\n      onPageSizeChange={pageSize => setState({ pageSize, pageNum: 1 })}\n    />\n  )}\n</State>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      State,
      Pagination
    }} mdxType="Playground">
  <State initial={{
        pageNum: 1,
        pageSize: 25
      }} mdxType="State">
    {({
          state,
          setState
        }) => <Pagination currentPage={state.pageNum} pageSize={state.pageSize} totalItems={200} onPageChange={pageNum => setState({
          pageNum
        })} onPageSizeChange={pageSize => setState({
          pageSize,
          pageNum: 1
        })} mdxType="Pagination" />}
  </State>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      